module.exports = __webpack_public_path__ + "static/media/f_logo.f5294b09.png";